import { RecordDistance } from '../api/types';

/** Catalog distance codes in catalog order. The codes are part of the API (DistanceCatalogSeeder). */
export const RECORD_CODES: RecordDistance[] = [
  '400m',
  '800m',
  '1000m',
  '1mile',
  '3k',
  '5k',
  '10k',
  '15k',
  '10mile',
  'half',
  'marathon',
];

/** True when `code` (from the URL) is a catalog distance code. */
export function isRecordCode(code: string): code is RecordDistance {
  return (RECORD_CODES as string[]).includes(code);
}
